import { PopupForm } from './PopupForm'
import { withPopupForm } from './withPopupForm'

const ConnectedPopupForm = withPopupForm(PopupForm)

export { ConnectedPopupForm as PopupForm }
